module.exports = __webpack_public_path__ + "img/upload-icon.d20703a5.svg";